import moment from "moment";
import CustomTable from "../../../../components/Tables/CustomTable";
import { useAppSelector } from "../../../../redux/app/hooks";
import DropdownMenu from "../../../ui/DropdownMenu";
import { MoreVertical } from "lucide-react";
import React, { useState } from "react";
import AddCourierAgent from "./AddAgent";
import EditCourierAgent from "./EditAgent";
import DisableAgentModal from "./AgentDeleteSuccess";

const AgentTable = ({
  page,
  setPage,
  setLimit,
  openAddAgent,
  setOpenAddAgent,
  onUpdate,
}: {
  page: number;
  setPage: any;
  setLimit: any;
  openAddAgent: any;
  setOpenAddAgent: any;
  onUpdate: () => void;
}) => {
  const { loading, agents } = useAppSelector((state) => state.courier);
  const [openEditAgent, setOpenEditAgent] = useState(false);
  const [disableAgent, setDisableAgent] = useState(false);
  const [selectedAgent, setSelectedAgent] = useState<any>();

  const dropdownOptionsForAgent = [
    {
      label: "Edit agent",
      onClick: (agent: any) => {
        setOpenEditAgent(true);
        setSelectedAgent(agent);
      },
      returnAll: true,
    },
    {
      label: <span className="text-red-500">Disable agent</span>,
      onClick: (agent: any) => {
        setDisableAgent(true);
        setSelectedAgent(agent);
      },
      returnAll: true,
    },
  ];

  const agentsData = {
    columns: [
      { label: "Name of Agent", field: "name" },
      { label: "Gender", field: "gender" },
      { label: "Email Address", field: "email" },
      { label: "Phone Number", field: "phone" },
      { label: "Name of Branch", field: "branch" },
      { label: "Reg Date", field: "reg_date" },
      // { label: "Status", field: "status" },
      { label: "Action", field: "action" },
    ],
    rows: agents?.data?.items?.map((item: any, index: number) => {
      return {
        id: index + 1,
        name: item?.agentName,
        email: item?.agentEmail,
        phone: item?.agentPhoneNumber,
        branch: item?.officeName,
        gender: item?.agentGender,
        reg_date: moment(item?.createdAt).format("Do MMM YYYY"),
        status: (
          <div
            className={`px-3 text-center py-1 rounded-full text-sm font-semibold ${
              item?.status === "ACTIVE"
                ? "bg-green-100 text-green-700"
                : "bg-red-100 text-red-700"
            }`}
          >
            {item?.status}
          </div>
        ),
        action: (
          <DropdownMenu
            options={dropdownOptionsForAgent}
            icon={<MoreVertical style={{ cursor: "pointer" }} />}
            item={item}
          />
        ),
      };
    }),
  };

  return (
    <>
      <CustomTable
        data={agentsData}
        noRecordText="No Agent Available"
        loading={loading}
        showFooter={true}
        totalPages={agents?.data?.meta?.totalPages}
        itemsPerPage={agents?.data?.meta?.itemsPerPage}
        currentPage={page}
        onPageChange={(value: number) => setPage(value)}
        onLimitChange={(value: number) => {
          setLimit(value);
          setPage(0);
        }}
      />
      <AddCourierAgent
        open={openAddAgent}
        onClose={() => setOpenAddAgent(false)}
        onSave={onUpdate}
      />
      <EditCourierAgent
        open={openEditAgent}
        onClose={() => setOpenEditAgent(false)}
        selectedAgent={selectedAgent}
        onSave={onUpdate}
      />
      <DisableAgentModal
        isOpen={disableAgent}
        onClose={() => setDisableAgent(false)}
        agentId={selectedAgent?.agentId}
        onConfirm={onUpdate}
      />
    </>
  );
};

export default AgentTable;
